import React from 'react'

export type TeamInfo = {
  memberType: 1 | 2 | 3
}
export type UserInfo = {
  id: string
}
export type AccountInfo = {
  categoryId: number
  rootCategoryId: number
  id: string
  teamInfo: TeamInfo
}
export const AccountContext = React.createContext({})
export const SampleAuthContext = React.createContext({})
export const MealAuthContext = React.createContext({})

export function useAccountContext() {
  return React.useContext(AccountContext) as AccountInfo
}
